"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterMatchesPreview = exports.isVisibleFreeBetInCategorizer = exports.getOpenedGameIds = exports.getCountAppliedFilters = void 0;
var lodash_1 = require("lodash");
var core_1 = __importStar(require("@gin-betting/core"));
var _a = core_1.default.utils, getFiltersFromLocation = _a.getFiltersFromLocation, getDefaultVariables = _a.getDefaultVariables;
var getHistory = core_1.default.services.getHistory;
function getCountAppliedFilters(calculationFields) {
    var searchObj = getFiltersFromLocation();
    return lodash_1.reduce(lodash_1.pick(searchObj, calculationFields), function (sum, curr) {
        if (!curr)
            return sum;
        if (lodash_1.isArray(curr))
            return (sum += curr.length);
        return ++sum;
    }, 0);
}
exports.getCountAppliedFilters = getCountAppliedFilters;
function getOpenedGameIds(categorizerData, currentOpenedGameIds, selectedTournamentIds, fixedTournamentIds) {
    return lodash_1.reduce(categorizerData, function (acc, currentGame) {
        var currentGameId = currentGame.value;
        var currentTournamentIds = lodash_1.map(currentGame.children, function (child) { return child.value; });
        var isCurrentGameFixed = lodash_1.intersection(fixedTournamentIds, currentTournamentIds).length >
            0;
        if (isCurrentGameFixed) {
            var nextAcc = __spreadArray([], acc);
            if (currentOpenedGameIds.includes(currentGameId)) {
                nextAcc.push(currentGameId);
            }
            return nextAcc;
        }
        if (lodash_1.intersection(currentTournamentIds, selectedTournamentIds)
            .length > 0) {
            return __spreadArray(__spreadArray([], acc), [currentGameId]);
        }
        return acc;
    }, []);
}
exports.getOpenedGameIds = getOpenedGameIds;
function isVisibleFreeBetInCategorizer() {
    return getHistory().location.pathname === core_1.App.Routes.UPCOMING_LIST;
}
exports.isVisibleFreeBetInCategorizer = isVisibleFreeBetInCategorizer;
var filterMatchesPreview = function (vars) {
    if (vars === void 0) { vars = {}; }
    var apiClient = core_1.default.appServiceLocator.get('apiClient');
    var defaultVariables = getDefaultVariables();
    // eslint-disable-next-line no-unused-vars
    var withMarketsCount = defaultVariables.withMarketsCount, rest = __rest(defaultVariables, ["withMarketsCount"]);
    var variables = __assign(__assign({}, rest), vars);
    var method = 'getMatchesPreviewByFilters';
    return apiClient.makeRequest({
        method: method,
        variables: variables,
    });
};
exports.filterMatchesPreview = filterMatchesPreview;
//# sourceMappingURL=utils.js.map